export default __webpack_public_path__ + "static/media/DSC_0932.7404d061.JPG";